import { ColorPalette, Colors } from '../constants';
const modes = [
    'faded',
    'light',
    'default',
    'dark'
];
export const getDestructuredColor = (color)=>{
    const [name = ''] = Object.entries(Colors).find(([, value])=>value === color) ?? [];
    const mode = modes.find((mode)=>name.toLowerCase().startsWith(mode)) ?? 'default';
    const base = name.replace(new RegExp(`^${mode}`, 'i'), '');
    return {
        base,
        mode
    };
};
export const getColorVariant = (color, variant = 'lighter')=>{
    const { base, mode } = getDestructuredColor(color);
    if (!ColorPalette[base]) {
        return color;
    }
    const newModeIndex = modes.indexOf(mode) + (variant === 'lighter' ? -1 : 1);
    if (newModeIndex < 0) {
        return Colors.White;
    } else if (newModeIndex >= modes.length) {
        return Colors.Black;
    } else {
        return ColorPalette[base][modes[newModeIndex]];
    }
};

//# sourceMappingURL=palette.js.map